import { from as from$ } from 'rxjs';

import LocationService from '../../../services/location.service';

export function getVehicleLocation(requestId, state) {
  return from$(LocationService.getVehicleLocation(requestId));
}
